import store from "../../../../store";
import { has } from "../../../../utils/menu-context";
import { commonComponentProp, commonInputPropField } from "../../inform/request/request.condition";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (record.createBy === store.state.resource.auth.info.user?.username
                // || (record.createBy === "anonymousUser" && record.refFreeSaleTemp?.refUser?.username === store.state.resource.auth.info.user?.username)
                || (record.refFreeSaleTemp?.refUser?.username === store.state.resource.auth.info.user?.username)
            ) {
                if ([undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forReceive" })) {
                if (["waitReceive"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forApprove" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canArchive: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canArchive" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canDelete: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canDelete" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canWaitReceive: ({ record }) => {
            let result = false;
            if (
                (record.createBy === store.state.resource.auth.info.user?.username ||
                    (record.createBy === "anonymousUser" &&
                        record.refFreeSaleTemp?.refUser?.username === store.state.resource.auth.info.user?.username)) &&
                !record.isOfficerCreate
            ) {
                if ([undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canWaitApprove: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forReceive" })) {
                if (["waitReceive"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (record.isOfficerCreate) {
                if (["draft", "reEditOfficer", "reEditAuthority"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canApprove: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            const userInfo = store.state.resource.auth.info?.user;
            if (has({ menuContext, key: "forApprove" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    if (record.refToApproveBy?.username === userInfo.username) {
                        result = true || result;
                    }
                }
            }
            return result;
        },
        canReStatus: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forRequest" })) {
                if (["waitReceive"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forReceive" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canReport: ({ record }) => {
            return !["draft"].includes(record.refStatus?.key);
        }
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return ["refFreeSaleTemp.refUserCompany.idCard"].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refDepartment.nameEn",
                    "lastStatus.waitReceive.0.statusDatetime",
                    "lastStatus.draft.0.statusDatetime",
                    "lastStatus.waitApprove.0.statusDatetime",
                    "refFreeSaleTemp.refUserCompany.companyNameEn",
                    "refFreeSaleTemp.refUser.fullNameEn",
                    "refFreeSaleTemp.refUserCompany.addresses.0.addrEn",
                    "refFreeSaleTemp.refUser.addresses.0.addrEn"
                ].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return ["refFreeSaleTemp.refUser.idCard"].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return ["refRequestType"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: []
            })
        },
        {
            check: ({ field }) => {
                return ["refDocGenType", "requestCode"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.isOfficerCreate;
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refFreeSaleTemp.approveCode"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.isOfficerCreate;
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["2", "3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refFreeSaleTemp.refUserCompany", "refDepartment"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["2", "3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refFreeSaleTemp.refUser"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refFreeSale"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["2", "3", "4"].includes(modelRef.refRequestType?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: []
            })
        },
        {
            check: ({ field }) => {
                return ["refFreeSaleTemp.refObjective"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["2", "3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return ["lastStatus.forRequestRemark.0.remark"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: []
            })
        },
        {
            check: ({ field }) => {
                return ["lastStatus.forReceiveRemark.0.remark"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    undefined,
                    "draft",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: []
            })
        },
        {
            check: ({ field }) => {
                return [
                    "refFreeSaleTemp.refHaz",
                    "refFreeSaleTemp.tradeNameTh",
                    "refFreeSaleTemp.refHazObject",
                    "refFreeSaleTemp.tradeNameEn",
                    "refFreeSaleTemp.isSolid",
                    "refFreeSaleTemp.isLiquid",
                    "refFreeSaleTemp.refSubStanceType",
                    "refFreeSaleTemp.manufacturer",
                    "refFreeSaleTemp.refManufactureCountry",
                    "refFreeSaleTemp.ph",
                    "refFreeSaleTemp.refType",
                    "refFreeSaleTemp.refSubStanceTypeMain",
                    "refFreeSaleTemp.refAnalysisAgency",
                    "refFreeSaleTemp.refAnalysisMethod",
                    "refFreeSaleTemp.isSubStanceActive",
                    "refFreeSaleTemp.refLd50",
                    "refFreeSaleTemp.ld50Operator",
                    "refFreeSaleTemp.ld50Value",
                    "refFreeSaleTemp.solid",
                    "refFreeSaleTemp.liquid",
                    "refFreeSaleTemp.refSubStanceActive",
                    "refFreeSaleTemp.analysisResult",
                    "refFreeSaleTemp.refCountry",
                    "refFreeSaleTemp.manufacturerEn",
                ].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            }),
            checkboxField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refFreeSaleTemp.toUse"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refFreeSaleTemp?.refHaz?.refType?.key === "1" /*&& ["22"].includes(modelRef.refRequestDoc?.key)*/ && modelRef.refFreeSaleTemp?.refObjective?.key === "1";
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refFreeSaleTemp.products"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refFreeSaleTemp?.refHaz?.refType?.key === "2";
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return (
                    field?.key?.startsWith("refFreeSaleTemp.attachments") &&
                    (field?.key?.endsWith("documentName") ||
                        field?.key?.endsWith("attribute.documentNo") ||
                        field?.key?.endsWith("attribute.documentDate") ||
                        field?.key?.endsWith("attribute.documentExpiredDate") ||
                        field?.key?.endsWith("size"))
                );
            },
            inputPropField: ({ modelRef, initialModel, record }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: []
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    if (["3", "4"].includes(modelRef.refRequestType?.key)) {
                        if (record?.attribute?.isDisabledDocumentName) {
                            common.disabled = true;
                        }
                    }
                }
                return common;
            }
        },
        {
            check: ({ componentKey }) => {
                return ["AttachmentInlineList"].includes(componentKey);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly } = props;
                let canCreate = false;
                let canDelete = false;
                if ([undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(initialModel.refStatus?.key)) {
                    canCreate = !viewOnly || canCreate;
                    canDelete = !viewOnly || canDelete;
                }
                return { canCreate, canDelete };
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^refFreeSaleTemp\\.addresses\\.[^\\.]+\\.(refAddressType|tel|fax|latitude|longitude|map)$`,
                    "g"
                ).test(field?.key);
            },
            visibleField: () => {
                return false;
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^refFreeSaleTemp\\.addresses\\.[^\\.]+\\.(noEn|roomEn|buildingEn|floorEn|villageEn|mooEn|soiEn|roadEn|refProvince|postCode|refAmphur|refTambon)$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },

        {
            check: ({ field }) => {
                return (
                    new RegExp(`^refFreeSaleTemp\\.refHaz$`, "g").test(field?.key) ||
                    new RegExp(`^refFreeSaleTemp\\.refHaz\\.lastStatus\\.forReceiveRemark\\.0\\.statusDatetime$`, "g").test(field?.key) ||
                    new RegExp(`^refFreeSaleTemp\\.(refHazObject|refHazObject\\.nameEn|refHazObject\\.refSpecies\\.value|refSubStanceType|labelNature|isSolid|solid|isLiquid|liquid|ph|tradeNameTh|tradeNameEn|manufacturer|refManufactureCountry|refType|products|refSubStanceTypeMain|refAnalysisAgency|refAnalysisMethod)$`, "g").test(field?.key)
                );
            },
            visibleField: ({ /*modelRef,*/ model }) => {
                return /*["22"].includes(modelRef.refRequestDoc?.key) &&*/ model.refObjective?.key === "1";
            }
        },
        {
            check: ({ field }) => {
                return (
                    new RegExp(`^refFreeSaleTemp\\.refInform$`, "g").test(field?.key) ||
                    new RegExp(`^refFreeSaleTemp\\.refInform\\.lastStatus\\.forReceiveRemark\\.0\\.statusDatetime$`, "g").test(field?.key) ||
                    new RegExp(`^refFreeSaleTemp\\.refInform\\.(importExportDate|refTransportObjective|refTransportByWay|containerNo|vehicleNo|refOriginDestinationCountry|sealNo|refExportCheckpoint|refImportCheckpoint|refPassCustoms|refHazObject|refOriginDestinationCountry|formula|manufacturer|storageName|refCoordinateCustoms)$`, "g").test(field?.key) ||
                    new RegExp(`^refFreeSaleTemp\\.refInformProduct\\.(refHazObject|refHazObject\\.refSpecies\\.value)$`, "g").test(field?.key)
                );
            },
            visibleField: ({ /*modelRef,*/ model }) => {
                return /*["22"].includes(modelRef.refRequestDoc?.key) &&*/ model.refObjective?.key === "2";
            }
        },
        {
            check: ({ componentKey }) => {
                return new RegExp(`^FreeSaleProductTable$`, "g").test(componentKey);
            },
            inputPropField: ({ modelRef }) => {
                if (["1", "2"].includes(modelRef.refRequestType?.key)) {
                    return { canCreate: true };
                } else if (["3", "4"].includes(modelRef.refRequestType?.key)) {
                    return { canCreate: false };
                }
                return commonComponentProp({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: ["3", "4"]
                });
            }
        },
    ];
};
